import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
const ProtectedRoute = ({ path, children }) => {
  let cookies = Cookies.get("data");
  let data = JSON.parse(base64_decode(cookies));
  
  let rolePermission = JSON.parse(localStorage.getItem("rolePermission"));

  if (!(rolePermission.includes(path) || rolePermission === "All")) {
    return <Navigate to={"/launchingDashboard"} replace />;
  }
  return children ? children : <Outlet />;
};
export default ProtectedRoute;
